//Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

//3rd party imports
import { plainToInstance } from 'class-transformer';

//RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

//Service imports
import { RPCacheRegistrationService } from '../../../_services/shared-services/rp-cache-registration-service';

//Model imports
import { BaseResidentParameterDto } from '../../../_models/base-resident-parameter-dto';
import { OnlineRequestCategoryResultDto } from '../../../_models/online-request-category-result-dto';
import { SubmitRequestParameterDto } from '../../../_models/submit-request-parameter-dto';
import { ResultStatusDto } from '../../../_models/result-status-dto';

//Service imports
import { EnvironmentConfigService } from '../../../_services/environment-config.service';

//Constants
import { CacheDuration } from '../../../_constants/cache-duration';

@Injectable({
  providedIn: 'root'
})
export class CommunityService {
  constructor(
    private httpClient: HttpClient,
    private cacheRegistrationService: RPCacheRegistrationService,
    private envConfig: EnvironmentConfigService
  ) {}

  getContactUsIssueCategories(
    data: BaseResidentParameterDto
  ): Observable<OnlineRequestCategoryResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'community/contactus/category' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<OnlineRequestCategoryResultDto[]>(url, options)
      .pipe(
        map((responseData: any[]) =>
          plainToInstance(OnlineRequestCategoryResultDto, responseData)
        )
      );
  }

  submitContactUsRequest(
    data: SubmitRequestParameterDto
  ): Observable<ResultStatusDto> {
    return this.httpClient
      .post<SubmitRequestParameterDto>(
        this.envConfig.ccResidentPortalApiUrl + 'community/contactus/submit',
        data
      )
      .pipe(
        map((responseData: any) =>
          plainToInstance(ResultStatusDto, responseData)
        )
      );
  }
}
